/* The provider reads these data attributes from its script element at execution. */
(() => {
  'use strict';
  if (customElements.get('woolie-reputation')) return;
  class Reputation extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.loaded) return;
      const load = () => {
        if (this.loaded || !this.isConnected) return;
        this.loaded = true;
        this.observer?.disconnect(); this.observer = null;
        const script = document.createElement('script');
        script.id = 'ra-embed-reputation';
        script.src = 'https://s3.amazonaws.com/raichu-beta/selos/bundle.js';
        script.async = true;
        script.dataset.id = this.dataset.id;
        script.dataset.target = this.dataset.target;
        script.dataset.model = '2';
        this.appendChild(script);
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) load(); }, {rootMargin:'300px 0px'});
        this.observer.observe(this);
      } else load();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  }
  customElements.define('woolie-reputation', Reputation);
})();
